// @flow

const parseGroupPanels = (panels: any): [string] | [] => {
  if (panels.length === 0) {
    return [];
  }

  return panels.map(panel => panel.propertyName);
};

export { parseGroupPanels };
